import SlideUp from "components/animation/SlideUp";

export default function AboutBox({image, alt, title, comment, index=0}) {

  const start = index*400;

  return (
    <div className="flex flex-col items-start lg:w-[400px]">
      <SlideUp delay={start}>
      <div className="hidden lg:block">
        <img src={image} alt={alt} className="lg:w-400 lg:h-400"/>
      </div>
      </SlideUp>
      <div className="lg:px-4">
        <SlideUp delay={start+300}>
        <div className="mt-6 mb-2 lg:w-[400px] lg:px-2 ">
          <p className="text-xl text-white lg:text-2xl">{title}</p>
        </div>
        </SlideUp>
        <SlideUp delay={start+350}>
        <div className="lg:w-[360px]">
          <p className="text-xs font-light text-white lg:text-sm">{comment}</p>
        </div>
        </SlideUp>
      </div>
    </div>
  );
}